import styles from './Profile.module.css';
import { Button, Flex, View, Text, Avatar } from '@adobe/react-spectrum';
import { SessionInfo } from '../../../data/SessionInfo';
import { useLocation } from 'react-router-dom';
// @ts-ignore
import jsonPackage from '../../../../package.json';

export interface IProfileProps {
    onLogout: () => void;
}

export function Profile ({
    onLogout
}: IProfileProps) {
    const { state } = useLocation();
    const session: SessionInfo = state.session;

    return (
        <Flex direction={'column'} gap="size-400" alignItems="center" UNSAFE_className={styles.profileContainer}>
            <View>
                <Avatar src="../assets/images/avatar--desktop--light@2x.png" size={100} />
            </View>
            <View>
                <Text UNSAFE_style={{ fontSize: '24px', fontWeight: 'bold' }}>
                    {session.sessionInfo.firstName} {session.sessionInfo.lastName}
                </Text>
            </View>
            <View>
                <Text UNSAFE_style={{ color: 'gray', fontSize: '16px' }}>
                    {session.sessionInfo.organizationName}
                </Text>
            </View>
            <Button variant={'negative'} UNSAFE_className={styles.logoutButton} onPress={onLogout}>
                Logout
            </Button>
            <View marginTop="size-400">
                <Text UNSAFE_style={{ color: 'gray', fontSize: '12px' }}>
                    v{jsonPackage.version}
                </Text>
                <Text UNSAFE_style={{ color: 'gray', fontSize: '12px' }}>
                    © {new Date().getFullYear()} Atollon. All rights reserved.
                </Text>
            </View>
        </Flex>
    );
}
